import React from "react";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { useAuthenticationHook } from "../../utils/hooks/useAuthenticationHook";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  ResourcesInfoContainer,
  ResourcesSingleFrameContainter,
  ResourcesTitleContainter,
} from "./Resources.styles";
import { ResourcesData } from "./ResourcesData";

interface ResourcesProps {
  showTitle?: boolean;
}

export const Resources = ({
  showTitle = true,
}: ResourcesProps): React.ReactElement => {
  const { deviceType } = useDeviceHook();
  const { auth, setLoggedOut } = useAuthenticationHook();

  return (
    <ResourcesSingleFrameContainter>
      {showTitle && (
        <ResourcesTitleContainter>
          {GetTypographyContent({
            content: "Resources",
            isBold: true,
            isCaps: true,
            size: "large",
            textColor: "greyMedium",
          })}
        </ResourcesTitleContainter>
      )}
      <ResourcesInfoContainer deviceType={deviceType} role="list">
        {ResourcesData(auth, setLoggedOut)}
      </ResourcesInfoContainer>
    </ResourcesSingleFrameContainter>
  );
};
